import React from 'react';
import { StyledHiddenHeading3 } from '../Footer.styles';
import { Link } from '@blueprint/link';
import {
    StyledIconList,
    ListItem,
    HiddenSpan
} from './SocialLinkSection.styles';
import {
    FacebookMonochromeLarge,
    TwitterMonochromeLarge,
    LinkedinMonochromeLarge,
    InstagramMonochromeLarge,
    PinterestMonochromeLarge,
    YoutubeMonochromeLarge
} from '@blueprint/icons';
import { useTheme } from '@emotion/react';

function SocialLinkSection() {
    const theme = useTheme();

    const newWindowText = 'This link opens in a new window';
    const fillColor = theme.colors['purple-dark'];

    return (
        <>
            <StyledHiddenHeading3>
                Links to Zoopla&#39;s social media accounts
            </StyledHiddenHeading3>
            <StyledIconList>
                <ListItem>
                    <Link
                        href="https://www.facebook.com/ZooplaUK"
                        target="_blank"
                        data-testid="social-link-facebook"
                        data-track-category="footer"
                        data-track-action="clickout"
                        data-track-label="facebook"
                        rel="noopener noreferrer nofollow"
                        title={newWindowText}
                    >
                        <FacebookMonochromeLarge fill={fillColor} />
                        <HiddenSpan>Zoopla Facebook page</HiddenSpan>
                    </Link>
                </ListItem>
                <ListItem>
                    <Link
                        href="https://twitter.com/zoopla"
                        target="_blank"
                        data-testid="social-link-twitter"
                        data-track-category="footer"
                        data-track-action="clickout"
                        data-track-label="twitter"
                        rel="noopener noreferrer nofollow"
                        title={newWindowText}
                    >
                        <TwitterMonochromeLarge fill={fillColor} />
                        <HiddenSpan>Zoopla Twitter profilee</HiddenSpan>
                    </Link>
                </ListItem>
                <ListItem>
                    <Link
                        href="https://www.linkedin.com/company/zoopla/about"
                        target="_blank"
                        data-testid="social-link-linkedin"
                        data-track-category="footer"
                        data-track-action="clickout"
                        data-track-label="linkedin"
                        rel="noopener noreferrer nofollow"
                        title={newWindowText}
                    >
                        <LinkedinMonochromeLarge fill={fillColor} />
                        <HiddenSpan>Zoopla LinkedIn profile</HiddenSpan>
                    </Link>
                </ListItem>
                <ListItem>
                    <Link
                        href="https://www.instagram.com/zoopla"
                        target="_blank"
                        data-testid="social-link-instagram"
                        data-track-category="footer"
                        data-track-action="clickout"
                        data-track-label="instagram"
                        rel="noopener noreferrer nofollow"
                        title={newWindowText}
                    >
                        <InstagramMonochromeLarge fill={fillColor} />
                        <HiddenSpan>Zoopla Instagram feed</HiddenSpan>
                    </Link>
                </ListItem>
                <ListItem>
                    <Link
                        href="https://www.youtube.com/user/ZooplaUK"
                        target="_blank"
                        data-testid="social-link-youtube"
                        data-track-category="footer"
                        data-track-action="clickout"
                        data-track-label="youtube"
                        rel="noopener noreferrer nofollow"
                        title={newWindowText}
                    >
                        <YoutubeMonochromeLarge fill={fillColor} />
                        <HiddenSpan>Zoopla YouTube channel</HiddenSpan>
                    </Link>
                </ListItem>
                <ListItem>
                    <Link
                        href="https://uk.pinterest.com/zoopla"
                        target="_blank"
                        data-testid="social-link-pinterest"
                        data-track-category="footer"
                        data-track-action="clickout"
                        data-track-label="pinterest"
                        rel="noopener noreferrer nofollow"
                        title={newWindowText}
                    >
                        <PinterestMonochromeLarge fill={fillColor} />
                        <HiddenSpan>Zoopla Pinterest board</HiddenSpan>
                    </Link>
                </ListItem>
            </StyledIconList>
        </>
    );
}

export default SocialLinkSection;
